import {
  AlertModal,
  AlertModalType,
  Button,
  Flex,
  FlexColumn,
  SecondaryButton,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useApplicationsContext } from '../../../contexts/applications';

const ReactivateModalContainer = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[5]};
`}`;

const ReactivateModalButtonContainer = styled(Flex)`${({ theme }) => `
  gap: ${theme.padding[2]};
  justify-content: end;
`}`;

function ReactivateModalContent({
  applicationId,
  close,
}:{ applicationId: string, close: () => void }) {
  const { reopenApplication } = useApplicationsContext();

  const onClick = () => {
    reopenApplication(applicationId);
    close();
  };

  return (
    <ReactivateModalContainer>
      <p>Are you sure you want to reactivate this application?</p>
      <ReactivateModalButtonContainer>
        <SecondaryButton small onClick={close}>Cancel</SecondaryButton>
        <Button small onClick={onClick}>Reactivate</Button>
      </ReactivateModalButtonContainer>
    </ReactivateModalContainer>
  );
}

export type ReactivateModalProps = Omit<AlertModalType, 'content'> & {
  applicationId: string;
  onClose: () => void;
}

export default function ReactivateModal({
  applicationId,
  onClose,
  ...props
}: ReactivateModalProps) {
  return (
    <AlertModal
      {...props}
      title="Reactivate the application"
      content={(
        <ReactivateModalContent
          applicationId={applicationId}
          close={onClose}
        />
      )}
      onClose={onClose}
      showButtons={false}
    />
  );
}
